import React, { useState } from 'react';
import MapList from './MapList';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';
import Pagination from '../../Common/Pagination';

export default function MapsContainer({ siteMapsData, onSelectDoc, viewDoc, downloadDoc, downloadAll, sectionName, sectionIcon }) {
    const [selectedPage, setSelectedPage] = useState(1);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let siteMapList;
    let noMaps;
    let downloadAllBtn;
    if (siteMapsData !== undefined) {
        siteMapList = siteMapsData.loading && "Loading";

        if (siteMapsData.loading === false) {

            if (siteMapsData.maps === undefined || siteMapsData.maps.length === 0) {
                noMaps = (<div className="centeredMessage"><h3>No maps available</h3></div>);
            }

            if (siteMapsData.maps && siteMapsData.maps.length > 0)
            {
                siteMapList = (<MapList
                    selected={siteMapsData.selected}
                    documentList={siteMapsData.maps}
                    onSelectDoc={onSelectDoc}
                    viewDoc={viewDoc}
                    downloadDoc={downloadDoc}
                    downloadAll={downloadAll}
                    selectedPage={selectedPage}
                    onSelectPage={handleSelectPage} />);

                let selectedCount = siteMapsData.maps.filter(doc => doc.selected).length;
                downloadAllBtn = selectedCount > 0 && (<button className="button" onClick={downloadAll}>Download</button>);
            }
        }
    }

    let pagination = (<Pagination itemCount={siteMapsData.maps?.length ?? 0} pageSize={10} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>{downloadAllBtn}</Pagination>);

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="ActiveSiteMapsContainer">
            <div className="ActiveSiteMaps">
                {siteMapList}
            </div>
            {noMaps}
        </div>
        {pagination}
    </>);
}